// noinspection JSValidateTypes,JSUnusedLocalSymbols

import React from 'react';
import {TableCell, TableSortLabel} from '@mui/material';
import { withStyles } from "@mui/styles";
import NullIcon from "../../../helpers/NullIcon";

const styles = {
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  small: {
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    display:'flex',
    flexDirection:'row',
    flexWrap:'nowrap'
  },
};

function ColumnHeader(props) {
  const {column, header, controller, handleOrderChange, classes, ...cellProps} = props;
  const key = column.key;
  const firstOrder = controller.orders[0];

  const tableSortLabel = (opt) => {
    let {sort, label} = opt;
    label = opt.hasOwnProperty('shortLabel') ? opt.shortLabel : label;
    const defAsc = opt.hasOwnProperty('asc') ? opt.asc : true;
    const active = firstOrder.f === sort;
    const nulls = active && opt.nulls && firstOrder.hasOwnProperty('n') && !firstOrder.n;
    const direction = nulls ? 'asc' : active ? (firstOrder.d ? 'asc' : 'desc') : defAsc ? 'asc' : 'desc'
    return sort === null ? label : (
      <TableSortLabel
        key={key + label + sort}
        active={active}
        direction={direction}
        onClick={() => handleOrderChange(sort, defAsc)}
        style={{fontWeight: 'bold', color: '#005985'}}
      >
        {label}
        {active ? (
          <span className={classes.visuallyHidden}>
            {firstOrder.d ? 'sorted ascending' : 'sorted descending'}
          </span>
        ) : null}
        {nulls ?
          <NullIcon style={{margin: '0 -4px 0 4px'}} />
          : null
        }
      </TableSortLabel>
    )
  };

  if(Array.isArray(header)){
    const orders = header.map((opt) => opt.sort).filter(item => !!item);
    const labels = header.map(opt => tableSortLabel(opt));
    return (
      <TableCell {...cellProps}
        sortDirection={orders.includes(firstOrder.f) ? (firstOrder.d ? 'asc' : 'desc') : false}
      >
        { header[0].hasOwnProperty('size') && header[0].size === "small" ?
          <div className={classes.small}>{labels[0]}</div>
          : <div>{labels[0]}</div>
        }
        <div className={classes.small}>{labels.slice(1)}</div>
      </TableCell>
    );
  }

  if(header.sort === null) {
    const label = header.hasOwnProperty('size') && header.size === "small" ?
      <div className={classes.small}>{header.labels}</div> : header.label;
    return ( <TableCell {...cellProps}>{label}</TableCell> );
  }

  const label = header.hasOwnProperty("size") && header.size === "small" ?
    <div className={classes.small}>{tableSortLabel(header)}</div> : tableSortLabel(header);
  return (
    <TableCell {...cellProps}
      sortDirection={firstOrder.f === header.sort ? firstOrder.d ? 'asc' : 'desc' : false }
    >
      {label}
    </TableCell>
  );
}

export default withStyles(styles)(ColumnHeader);
